import React from "react";
import { Button } from "react-bootstrap";
import Multiselect from 'react-widgets/lib/Multiselect';
import { Image } from "react-bootstrap";
import * as permissions from '../../constants/permissions';
import { connect } from "react-redux";

const renderHead = () => (<thead>
    <tr>
        <td>Id</td>
        <td>Название</td>
        <td>Категория</td>
        <td>Цена</td>
        <td>Ед. измерения</td>
        <td>Время чистки</td>
        <td>Страховка</td>
        <td>Активна</td>
        <td>Отображать на сайте</td>
        <td>Иконка</td>
        <td></td>
    </tr>
</thead>);

let ServiceTable = class extends React.Component {
    _editClick(service) {
        this.props.editClick(service);
    }

    render() {
        const { entities: services, icoTimestamp } = this.props;
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        return (<table className='table table-hover'>
            {renderHead()}
            <tbody>
                {services && services.map(s => {
                    const onEditClick = this._editClick.bind(this, s);
                    return (
                        <tr key={s.Id}>
                            <td>{s.Id}</td>
                            <td>{s.Name}</td>
                            <td>
                                <div >
                                    <Multiselect
                                        value={s.Categories}
                                        data={s.Categories}
                                        valueField="Id"
                                        textField="Name"
                                        readOnly
                                        disabled
                                        onChange={() => { }}
                                    />
                                </div>
                            </td>
                            <td>{s.Price}</td>
                            <td>{s.Unit}</td>
                            <td>{s.CleaningTime}</td>
                            <td>{s.Insurance}</td>
                            <td>{s.IsActive ? 'Да' : 'Нет'}</td>
                            <td>{s.IsVisible ? 'Да' : 'Нет'}</td>
                            <td><Image src={`api/services/${s.Id}/image?t=${new Date().getTime()}`} height='35px' /></td>
                            <td>
                                <Button disabled={isReadOnly} onClick={onEditClick}>Редактировать</Button>
                            </td>
                        </tr>);
                })}
            </tbody>
        </table>);

    }
};

ServiceTable = connect((state, props) => {
    const icoTimestamp = state.application.get('serviceCategory').get('category').icoTimestamp;
    return {
        icoTimestamp
    };
}, { })(ServiceTable);

export default ServiceTable;


// WEBPACK FOOTER //
// ./src/components/services/ServiceTable.jsx